require('./_set-species')('Array');


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/es6.array.species.js
 ** module id = 430
 ** module chunks = 2 4 6 8 9 11 12
 **/